import React, { useState } from 'react';
import PdfIcon from '../../static/icons/pdf-icon-small.svg';
import ImageIcon from '../../static/icons/Image_icon.svg';

// The icon at the start of a stimulus pill: an image's own thumbnail, else the
// text, PDF or image icon. A thumbnail that is missing or fails to load shows
// the image icon instead of a broken image. `Thumb` and `Icon` are the caller's
// styled <img> elements, so each pill keeps its own sizing.
const StimulusPillIcon = ({ item, textIcon, Thumb = 'img', Icon = 'img' }) => {
  const [failedUrl, setFailedUrl] = useState(null);
  if (item.type === 'image' && item.url && item.url !== failedUrl) {
    return (
      <Thumb
        src={item.url}
        alt=""
        aria-hidden="true"
        onError={() => setFailedUrl(item.url)}
      />
    );
  }
  const src =
    item.type === 'text' ? textIcon : item.type === 'pdf' ? PdfIcon : ImageIcon;
  return <Icon src={src} alt="" aria-hidden="true" data-pill-icon={item.type} />;
};

export default StimulusPillIcon;
